import { Pencil1Icon, TrashIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { Lists } from '../../components/common/Lists';
import TableComponent from '../../components/common/Tables';
import { useAppDispatch } from '../../hooks/hooks';
import { useGetSubjectsQuery } from '../../hooks/useGetSubjectsQuery';
import { setUpdateSubjectData } from '../../redux/slices/school/subject';
import { routes } from '../../routes';
import { deleteSubject } from '../../services/school/subject/deleteSubject';
import { SubjectType, UpdateSubjectType } from '../../types/Subject';

const columnNamesMap: { [key: string]: string } = {
  description: 'Descrição',
  scientificArea: 'Área Científica',
  precedence: 'Precedência',
};
export const Subjects = () => {

  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { data, status } = useGetSubjectsQuery({ PageNumber: currentPage, PageSize: 400 });
  const mutationDelete = useMutation(deleteSubject, {
    onSuccess: () => {
      queryClient.invalidateQueries('subjects-pagination');
      toast.success('Apagado');
    },
    onError: () => {
      toast.error("Erro ao apagar.")
    }
  });

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };
  const handleClickCreate = (event: any): void => {
    navigate(routes.createSubject)
  }
  const handleEdit = (subject: UpdateSubjectType) => {
    dispatch(setUpdateSubjectData(subject));
    navigate(routes.updateSubject)
  };

  const handleDelete = (subject: SubjectType) => {
    try {
      mutationDelete.mutateAsync(subject.id)

    } catch (error: any) {
      toast.error(`${mutationDelete.error ?? error?.message}`);

    }
  };

  const options = data?.items.map(() => [
    {
      label: 'Editar',
      onClick: (subject: SubjectType) => handleEdit(subject),
      icon: <Pencil1Icon />
    },
    {
      label: 'Excluir',
      onClick: (subject: SubjectType) => handleDelete(subject),
      icon: <TrashIcon />
    }, 

  ]) || [];

  return (
    <Lists
      status={status}
      TableComponent={() =>
        <TableComponent
          columns={Object.keys(columnNamesMap)}
          items={data?.items}
          options={options}
          columnNamesMap={columnNamesMap}
          totalPages={data?.totalPages || 1}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      }
      handleClickCreate={handleClickCreate}
    />
  );
}